import React from "react"
import "./color.css"

const FullStar = () => {
	return (
		<div className="full-star">
			<svg width="484.05" height="488.51" viewBox="0 0 484.05 488.51">
				<defs>
					<pattern
						id="pattern"
						preserveAspectRatio="none"
						width="100%"
						height="100%"
						viewBox="0 0 3229 513"
					></pattern>
				</defs>
				<g id="star_full" transform="translate(-13.93 -11)">
					<rect
						id="Rectangle_2"
						data-name="Rectangle 2"
						width="484.05"
						height="75.2"
						transform="translate(13.93 424.31)"
						opacity="0.4"
						fill="url(#pattern)"
					/>
					<path
						id="Path_4"
						data-name="Path 4"
						d="M146.71,292.75,37.14,213.63s-21.63-12.81-15.37-32.45c6.54-19.92,31.59-17.07,31.59-17.07h134.9L230.1,35.48S235.22,11,256,11s25.9,24.48,25.9,24.48l41.55,128.64,135.18-.29s25-2.56,31.59,17.36c6.26,19.64-15.37,32.16-15.37,32.16l-109.29,79.4L407.4,421.39s10,23.05-6.83,35.29c-16.79,12-35.29-4.84-35.29-4.84L256,372.44,146.71,452.12s-18.5,16.79-35.29,4.55-6.55-35.29-6.55-35.29Z"
						fill="#FFD700"
					/>
					<path
						id="Path_5"
						data-name="Path 5"
						d="M26.61,179.48c9.68-10.53,26.75-8.54,26.75-8.54h140L231,54.83c6.83-23.62,12.24-36.43,24.76-36.14,11.38,0,16.79,11.1,24.48,34.15l38.42,118.11,140-.29s17.07-1.71,26.75,8.82c-13.38-6-109.86-.57-171.61,0L270.23,40.88c-7.69-24.76-23.62-20.77-29.31,1.71L199.08,179.48C134.76,178.34,33.16,170.94,26.61,179.48Z"
						fill="#FFD700"
					/>
				</g>
			</svg>
		</div>
	)
}

export default FullStar
